import React from 'react';

import { format, getZonedDate } from '@eika-infrastruktur/date';

import { useConfig } from '../../../../../defaultConfig';
import useTranslation from '../../../../../hooks/useTranslation';
import CurrencyExchange from '../../CurrencyExchange';
import useFormContext from '../../form/useFormContext';

const AmountSummary: React.FC = () => {
    const translated = useTranslation();
    const { state } = useFormContext();
    const { featureToggles } = useConfig();
    const date = state.paymentDate || getZonedDate();

    return (
        <li key="amountSummary" className="amount-date__list-item">
            <h3 className="summary-description__title">{translated.crossBorderPayment.summary.amountDateTitle}</h3>
            <dl>
                <dt className="summary-description__term summary-description__spacing-to-title">
                    {translated.crossBorderPayment.summary.amount}
                </dt>
                <dd className="summary-description__info summary-description__extra-spacing">{`${state.amount} ${state.currency}`}</dd>
            </dl>
            {state.amount && <CurrencyExchange amount={state.amount} selectedCurrency={state.currency} />}
            <dl className="summary-description__term-list">
                <dt className="summary-description__term">{translated.currencyField.label}</dt>
                <dd className="summary-description__info summary-description__extra-spacing">
                    {String(state.currency ?? state.country?.currency ?? 'EUR')}
                </dd>
                {state.transferCurrency && (
                    <>
                        <dt className="summary-description__term">{translated.currencyField.title}</dt>
                        <dd className="summary-description__info summary-description__extra-spacing">
                            {String(state.transferCurrency)}
                        </dd>
                    </>
                )}
                <dt className="summary-description__term">{translated.date}</dt>
                <dd className="summary-description__info summary-description__extra-spacing">
                    {format(date, 'dd MMMM')}
                </dd>
                {featureToggles.enableCrossBorderPriority && (
                    <>
                        <dt className="summary-description__term">{translated.priorityField.label}</dt>
                        <dd className="summary-description__info summary-description__extra-spacing">
                            {state.priority && translated.priorityOption[state.priority]}
                        </dd>
                    </>
                )}
                {!state.country?.partOfSepa && (
                    <>
                        <dt className="summary-description__term">{translated.chargeBearerField.title}</dt>
                        <dd className="summary-description__info">
                            {state.chargeBearer && translated.chargeBearerSelectOptions[state.chargeBearer]}
                        </dd>
                    </>
                )}
            </dl>
        </li>
    );
};

export default AmountSummary;
